<template>
  <el-dialog class="demand_model_dialog" top="5vh" center title="人效展示" width="95%" :before-close="handleClose"
             :visible.sync="dialogVisible" :close-on-click-modal="false">
    <div class="devOps_producerSpacePersonDetail" v-loading="loading">
      <el-row :gutter="10" style="margin-bottom:10px">
        <el-col :span="12">
          <div class="pie_chart_div">
            <div ref="myChartPie" id="myChartPie"></div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="bar_chart_div">
            <div ref="myChartBar" id="myChartBar"></div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-bottom:10px;">
        <el-col :span="24">
          <div class="bar_chart_div" style="background-color: #f4f5f8;padding-top: 3px">
            <div ref="myChartBar2" id="myChartBar2" style="background-color: #fff;"></div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
import * as echarts from "echarts";
import {getDevOpsSpacePersonnelDetailApi} from "@/server/tops/devOps";
export default {
  name: 'PersonDetailPage',
  components: {},
  data () {
    return {
      loading: false,
    }
  },
  props:{
    back: {
      type: String,
      default: '',
    },
    searchForm: {
      type: Object,
      default: {},
    },
    startDate:{
      type: String,
      default: '',
    },
    endDate:{
      type: String,
      default: '',
    },
    pageNum:{
      type: String,
      default: '',
    },
    pagecSize:{
      type: String,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  mounted() {
    this.$nextTick(async () => {
      await this.getData();
      /* let xdata = ['1-3', '4-6', '7-12', '>12'];
       let Bardata = [120, 200, 150, 80, 70, 110, 130];
       this.drawBar(xdata,Bardata,'myChartBar','工时分布');*//*
      let xdata2 = ['尚国胜','马晓磊', '尚国胜', '尚国胜','马晓磊','尚国胜','马晓磊', '尚国胜', '尚国胜','马晓磊','尚国胜','马晓磊', '尚国胜', '尚国胜','马晓磊','尚国胜','马晓磊', '尚国胜', '尚国胜','马晓磊','尚国胜','马晓磊', '尚国胜', '尚国胜','马晓磊', '尚国胜','马晓磊', '尚国胜','马晓磊', '尚国胜', '尚国胜','马晓磊', '尚国胜', '尚国胜','马晓磊', '尚国胜','马晓磊', '尚国胜','马晓磊', '尚国胜'];
      let Bardata2 = [1, 2, 3, 4, 5, 6, 7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40];
      this.drawBar(xdata2,Bardata2,'myChartBar2','人员任务完成工时分布');*/
    })
  },
  methods:{
    // 关闭弹窗
    handleClose(step) {
      if(this.back){
        this.hideDialogVisible('project')
      }else{
        this.hideDialogVisible(step)
      }
    },
    async getData() {
      try {
        this.loading = true;
        let params = this.searchForm;
        await getDevOpsSpacePersonnelDetailApi({...params,teamId: params.teamId.toString()}).then((res) => {
          if (res.data) {
            //工时占比OK
            if (res.data.estimate_work_pie_chart) {
              const Piedata = [{
                value: res.data.estimate_work_pie_chart.finish_estimate_work,
                name: '已完成'
              }, {
                value: res.data.estimate_work_pie_chart.unfinish_estimate_work,
                name: '未完成'
              }, {
                value: res.data.estimate_work_pie_chart.vacant_estimate_work,
                name: '空余'
              }];
              this.drawPie(Piedata, 'myChartPie', '工时占比');
            }
            if(res.data.estimate_work_distributed){
              let xdata = [];
              let Bardata = [];
              Object.keys(res.data.estimate_work_distributed).forEach((item,i) => {
                xdata.push(item);
                Bardata.push(res.data.estimate_work_distributed[item]);
              });
              this.drawBar(xdata,Bardata,'myChartBar','工时分布','任务数量','工时区间');
            }
            if(res.data.date_user){
              let xdata2 = [];
              let Bardata2 = [];
              Object.keys(res.data.date_user).forEach((item2,i2) => {
                xdata2.push(res.data.date_user[item2].nameZh);
                Bardata2.push(res.data.date_user[item2].finish_work);
              });
              this.drawBar(xdata2,Bardata2,'myChartBar2','人员任务完成工时分布','工时');
            }
          }
        })
      }catch (error){
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      }finally {
        this.loading = false;
      }
    },
    drawPie(seriesData, ele, title) {
      // 指定图表的配置项和数据
      const option = {
        backgroundColor: '#fff',
        title: {
          text: title,
          left: 'center',
          top: '3%',
          textStyle: {
            // color: '#fff',
            fontSize: '16px',
          },
        },
        // color:color,
        legend: {
          orient: 'vertical',
          bottom: 'bottom',
          textStyle: {
            color: '#666',
          },
          itemStyle: {
            borderRadius: 5,
            borderColor: '#fff',
            borderWidth: 1,
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
          /* position: function (point) {
             return [point[0], point[1]]; // 将 x轴坐标向右移动 10px
           }*/
        },
        series: [
          {
            name: title,
            data: seriesData,
            type: 'pie',
            radius: '50%',
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0)'
              }
            },
          },
        ],
      };
      const myChartPie = echarts.init(this.$refs[ele]);
      myChartPie.setOption(option);
      return myChartPie;
    },
    drawBar(xData,seriesData, ele, title, yAxisName = '', xAxisName = ''){
      const max = this.maxValue(seriesData);
      const option = {
        backgroundColor: '#fff',
        title: {
          text: title,
          left: 'center',
          top: '3%',
          textStyle: {
            // color: '#fff',
            fontSize: '16px',
          },
        },
        legend: {
          textStyle: {
            color: '#888',
          },
          top: '5%',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        barWidth: 20,
        grid: {
          left: '1%',
          bottom: '3%',
          right:'20%',
          containLabel: true,
        },
        dataZoom: [//给x轴设置滚动条
          {
            start:0,//默认为0
            end: (20/xData.length) * 100, //这个值可为动态，（5/x轴值的数量）*100
            type: 'slider',
            show: xData.length > 20,
            xAxisIndex: [0],
            handleSize: 0,//滑动条的 左右2个滑动条的大小
            height: 8,//组件高度
            left: 50, //左边的距离
            right: 40,//右边的距离
            bottom: 0,//右边的距离
            handleColor: '#ddd',//h滑动图标的颜色
            handleStyle: {
              borderColor: '#cacaca',
              borderWidth: '1',
              shadowBlur: 2,
              background: '#ddd',
              shadowColor: '#ddd',
            },
            fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
//给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
//给第一个设置0，第四个设置1，就是垂直渐变
              offset: 0,
              color: '#1eb5e5'
            },
              {
                offset: 1,
                color: '#5ccbb1'
              }]),
            backgroundColor: '#ddd',//两边未选中的滑动条区域的颜色
            showDataShadow: false,//是否显示数据阴影 默认auto
            showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
            handleIcon: 'M0,0 v9.7h5 v-9.7h-5 Z',
            filterMode: 'filter'
          },
//下面这个属性是里面拖到
          /*   {
               type: 'inside',
                   show: true,
                 xAxisIndex: [0],
                 start: 0,//默认为1
                 end: 50
             },*/
        ],
        xAxis: {
          name: xAxisName,
          type: 'category',
          data:xData || [],
          axisLabel: {},
        },
        yAxis: {
          name: yAxisName,
          type: 'value',
          min:0,
          max:max,
          minInterval: 1,
        },
        series: [
          {
            data: seriesData,
            type: 'bar'
          }
        ]
      };
      if(ele === 'myChartBar2'){
        option.xAxis.axisLabel = {
          formatter: function (value, index) {
            let arr = value.split('');
            return arr.join('\n');
          },
        }
        option.grid.right = '3%';
      }
      const myChartBar = echarts.init(this.$refs[ele]);
      myChartBar.setOption(option);
    },
    maxValue(arrayData) {
      if (arrayData && arrayData.length > 0) {
        let max = Math.max.apply( null, arrayData );
        if(max > 10){
          let res = Math.ceil(max/10) * 10;
          return res;
        }
        return 10;
      } else {
        return 10;
      }
    }
  },
}
</script>
<style lang="scss">
.devOps_producerSpacePersonDetail{
  /* background-color: #f4f5f8;*/
  #myChartPie,#myChartBar,#myChartBar2{
    height: 300px;
  }
}

</style>
